import Vue from 'vue'
import CZQPopupList from './CZQPopupList.vue'

var popupList = null

export default function () {
	if (!popupList) {
		popupList = new Vue({
			extends: CZQPopupList
		})
		popupList.$mount()
		document.body.appendChild(popupList.$el)
		this.$router.beforeEach((to, from, next) => {
			popupList.hideSelect().then(next)
		})
	}
	return popupList.open(...arguments)
}



// WEBPACK FOOTER //
// ./src/lib/czqui/popup-list/service.js